import Vue from 'vue';

export const ENCUESTA_TWILIO_EVENT = 'rh-encuesta-twilio-pendiente';
export const PUESTOS_ENCUESTA_TWILIO = [11, 18, 19];
export const USUARIOS_EXENTOS_ENCUESTA_TWILIO = [623];

export const encuestaTwilioBus = new Vue();

export function esUsuarioExentoEncuestaTwilio(usuario) {
  if (!usuario) return false;
  const iderp = usuario.iderp != null ? usuario.iderp : usuario.id_usuario;
  if (iderp == null || iderp === '') return false;
  return USUARIOS_EXENTOS_ENCUESTA_TWILIO.includes(Number(iderp));
}

export function aplicaEncuestaTwilio(usuario) {
  // Encuesta de rendimiento Twilio desactivada (ya no se muestra al entrar).
  return false;
}

export function notificarEncuestaPendiente(mensaje) {
  encuestaTwilioBus.$emit(ENCUESTA_TWILIO_EVENT, mensaje || null);
}

export function esErrorEncuestaTwilio(error) {
  const data = error && error.response && error.response.data;
  if (!data) return false;
  return data.code === 'ENCUESTA_TWILIO_PENDIENTE' || data.encuestaPendiente === true;
}

export function mensajeErrorEncuestaTwilio(error) {
  const data = error && error.response && error.response.data;
  return (data && data.message) || 'Actualiza tu plataforma (F5 o Ctrl+F5) para continuar.';
}
